import { Button, Empty, Flex } from 'antd';
import { SectionTitle } from '../styles';
import { Assistance, CauseContainer } from './styles';
import Icon from '@ant-design/icons';
import { SVGOrder, SVGPhone } from '../../../../images';
import Result from './result';
import { Cause } from '../../../../types';
import PossibleCauseItem from './causeItem';
import { useSelector } from 'react-redux';
import { selectRoutines } from '../../../../slices/templates';
import { useTranslation } from 'react-i18next';

export interface PossibleCause extends Cause {
  ratio: number;
  causeID: string;
  causeName: string;
}

const PossibleCauses = ({
  identified,
  causes,
}: {
  identified?: boolean;
  causes: PossibleCause[];
}) => {
  const { t } = useTranslation();
  const routines = useSelector(selectRoutines);
  const routine = routines.find((i) => {
    const linkedCausesList = i.linkedCauses as Cause[] | undefined;
    if (Array.isArray(linkedCausesList)) {
      return linkedCausesList.some(
        (c) => String(c.causeID) === String(causes?.[0]?.causeID)
      );
    }
    return false;
  });

  return (
    <CauseContainer className={identified ? 'identified' : ''}>
      <SectionTitle>
        {identified ? t('identified_causes') : t('possible_causes')}
        <span>({causes.length})</span>
      </SectionTitle>
      <Flex flex={1} vertical gap={8} style={{ overflowY: 'auto' }}>
        {causes.length ? (
          causes.map((c, index) =>
            c ? (
              <PossibleCauseItem
                key={c.causeID}
                causes={causes}
                cause={c}
                index={index}
              />
            ) : null
          )
        ) : (
          <Empty description={t('no_possible_causes')} />
        )}

        {identified && <Result routine={routine} />}
      </Flex>
      <Assistance>
        <p>{t('need_assistance')}</p>
        <Flex gap={24}>
          <Button ghost type="primary" icon={<Icon component={SVGPhone} />}>
            {t('call_machine_builder')}
          </Button>
          <Button ghost type="primary" icon={<Icon component={SVGOrder} />}>
            {t('create_ticket')}
          </Button>
        </Flex>
      </Assistance>
    </CauseContainer>
  );
};

export default PossibleCauses;
